import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { styled } from '@mui/system';

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  '&.MuiAccordionDetails-root': {
    padding: theme.spacing(2),
  },
}));

export default AccordionDetails;
